<template>
  <div>
    <div v-show="!success">
      <div class="alert alert-info" v-show="!failedMessage">
        You are signing up for
        <b>{{ministryRole.name}}</b>
        in {{ministryRole.department}}!
      </div>
      <div class="alert alert-danger" v-show="failedMessage">{{failedMessage}}</div>
      <div style="text-align:left;">
        <a href="https://www.hopesingapore.org.sg/contributeroles"><< Back</a>
      </div>
      <div class="row col-md-10 offset-md-1 col-xs-12 text-left ml-2">
        <small>
          <p>By submitting information to Hope Church Singapore, I:</p>
          <ol>
            <li>confirm all personal data disclose herein is accurate</li>
            <li>agree and consent to Hope Church Singapore's collection, use, disclosure and/or sharing of all personal data disclosed herein, for the purpose of interaction, planning of activities and communication of events, programmes and church-related information.</li>
          </ol>

          <p>Note: If you are serving as a higher leader role or Approver is incorrect, please write in to contribute@hopesingapore.org.sg to sign up.</p>
        </small>
      </div>
      <div>
        <ul style="color:red; text-align:left;">
          <li v-for="error in errors">{{error}}</li>
        </ul>
        <div class="mx-3 row">
          <input
            type="numbers"
            class="form-control my-1 mx-2 col-xs-12 col-md-3"
            placeholder="Enter your mobile phone (8 digits)"
            size="30"
            v-model="ministryRequest.candidateMobile"
            maxlength="8"
            :disabled="otpRequested"
          />
          <button
            :disabled="timeleft > 0 || otpVerified"
            class="btn btn-info my-1 mx-2 col-md-2 col-xs-12"
            v-on:click="sendOtp"
          >
            <span v-show="timeleft === 0">Request OTP</span>
            <span v-show="timeleft > 0">{{timeleft}}</span>
          </button>
          <input
            type="text"
            class="form-control my-1 mx-2 col-md-3 col-xs-12"
            placeholder="Enter OTP Received"
            v-model="otpInput"
            :disabled="otpVerified"
          />
          <button
            class="btn btn-success my-1 mx-2 col-md-2 col-xs-12"
            v-on:click="verifyOtp"
            :disabled="!otpRequested"
          >Verify</button>
        </div>
        <br />
        <div class="mx-3 row" v-show="showUserDetails && ministryRole">
          <input
            type="text"
            v-model="ministryRequest.candidateName"
            class="form-control my-1 mx-2 col-md-3 col-xs-12"
            placeholder="Your Name"
          />
          <input
            type="text"
            v-model="ministryRequest.candidateEmail"
            class="form-control my-1 mx-2 col-md-3 col-xs-12"
            placeholder="Your Email (Optional)"
          />
          <div class="form-check ml-3" v-show="!isLeader">
            <input
              type="checkbox"
              class="form-check-input"
              v-show="ministryRole.requirement >= 2"
              v-model="ministryRequest.noLG"
              placeholder="I don't have a LG"
              id="noLG"
            />
            <label
              for="noLG"
              v-show="ministryRole.requirement >= 2"
              class="form-check-label"
            >I don't have a LG/I can't find my LG.</label>
          </div>
        </div>
        <div class="mx-3 row" v-show="showUserDetails && !ministryRequest.noLG">
          <select
            class="form-control my-1 mx-2 col-md-3 col-xs-12"
            v-model="ministryRequest.centre"
            v-on:change="getCongregations"
            :disabled="isLeader"
          >
            <option disabled value>Your centre...</option>
            <option v-for="centre in centres">{{centre}}</option>
          </select>
          <select
            class="form-control my-1 mx-2 col-md-3 col-xs-12"
            v-model="ministryRequest.congregation"
            :disabled="ministryRequest.centre == ''"
          >
            <option disabled value>Your congregation...</option>
            <option v-for="congregation in congregations">{{congregation}}</option>
          </select>
          <div class="col-md-3 col-xs-12 my-1">
            <autocomplete
              :source="findLifegroupUri()"
              results-value="lifegroup"
              :disable-input="ministryRequest.congregation === ''"
              input-class="form-control "
              results-display="lifegroup"
              v-model="ministryRequest.lifegroup"
              placeholder="Find your lifegroup"
            ></autocomplete>
          </div>
          <div class="col-md-9 col-xs-12 my-1">
            <textarea
              class="form-control"
              v-model="ministryRequest.candidateRemarks"
              placeholder="Tell us if you have relevant skills and/or experiences"
            ></textarea>
          </div>
        </div>
        <br />
        <div class="mx-3 row">
          <select
            v-model="approver"
            v-show="showApproverDetails || isLeader"
            class="form-control my-1 mx-2 col-md-3 col-xs-12"
          >
            <option disabled value>Choose your approver</option>
            <option v-for="a in approvers" :value="a">{{a.approverName}}</option>
          </select>

          <button
            class="btn btn-primary my-1 mx-2 col-md-3 col-xs-12"
            :disabled="failedMessage"
            v-show="showApproverDetails || ministryRequest.noLG || isLeader"
            v-on:click="signup"
          >Submit</button>
        </div>
      </div>
    </div>
    <div v-show="success">
      <br />
      <br />
      <br />
      <p>You have successfully signed up for {{this.ministryRole.name}}.</p>
      <p>
        Click
        <a href="https://www.hopesingapore.org.sg/contributeroles">here</a> to browse other ministries.
      </p>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  name: "SignUp",
  props: {
    msg: String
  },
  data: function() {
    return {
      ministryRole: {},
      ministryRequest: {
        centre: "",
        congregation: "",
        lifegroup: "",
        candidateEmail: "",
        noLG: false
      },
      approver: "",
      showUserDetails: false,
      showApproverDetails: false,
      errors: [],
      submitting: false,
      congregations: [],
      centres: [],
      timeleft: 0,
      otpCounter: {},
      otpInput: "",
      otpRequested: false,
      otpVerified: false,
      lgStructures: [],
      approvers: [],
      success: true,
      failedMessage: null,
      isLeader: false
    };
  },
  methods: {
    findApprover: async function() {
      try {
        let response = await http.get(
          "/structure/approver?mobile=" + this.ministryRequest.candidateMobile
        );
        this.isLeader = true;
        let approvers = response.data.approvers;
        let candidate = response.data.candidate;
        approvers.forEach(s => {
          let a = {
            approverName: s.displayName,
            approverMobile: s.mobile,
            approverEmail: s.email
          };
          this.approvers.push(a);
        });

        this.ministryRequest.candidateName = candidate.displayName;
        this.ministryRequest.candidateEmail = candidate.email;
        alert(
          "You appear to be a leader. You do not have to enter Centre, Congregation and LifeGroup selection."
        );
      } catch (err) {
        // not found
        console.log('findApprover err', err);
      }
    },
    findLifegroupUri: function() {
      let query =
        http.host +
        "/structure/filter?q=find lifegroup&c=" +
        this.ministryRequest.congregation +
        "&term=";
      return query;
    },
    getMinistryRole: async function() {
      var response = await http.get(
        '/ministryRole?where={"name":"' + this.$route.query.role + '"}'
      );
      if (response.status == 200) {
        this.ministryRole = response.data[0];
      }
    },
    signup: async function() {
      this.ministryRequest.approverName = this.approver.approverName;
      this.ministryRequest.approverMobile = this.approver.approverMobile;
      if (
        typeof this.approver.email !== "undefined" &&
        this.approver.email.length > 0
      ) {
        this.ministryRequest.approverEmail = this.approver.approverEmail;
      }

      if (this.validate() > 0) {
        console.log("error, returned.");
        return;
      }
      this.submitting = true;

      let postData = {
        ministryRole: this.ministryRole,
        ministryRequest: this.ministryRequest
      };
      try {
        console.log("fire http request");
        var response = await http.post("/ministry/signup", postData);
        if (response.status == 200) {
          this.success = true;
        }
      } catch (err) {
        if (err.response.status == 400) {
          this.failedMessage = err.response.data.message;
        }
        console.log("error", err);
      }
      this.submitting = false;
    },

    getCongregations: async function() {
      try {
        let response = await http.get(
          "/structure/filter?q=distinct congregation&term=" +
            this.ministryRequest.centre
        );
        this.congregations = response.data;
      } catch (err) {
        alert(
          "Unable to fetch congregation information. Please reload the page and try again."
        );
      }
    },
    getCentres: async function() {
      try {
        let response = await http.get("/structure/filter?q=distinct centre");
        this.centres = response.data;
      } catch (err) {
        alert(
          "Unable to fetch centre information. Please reload the page and try again."
        );
      }
    },
    sendOtp: async function() {
      if (this.validateOtp() > 0) {
        return;
      }

      try {
        let response = http.post("/otp", {
          mobile: this.ministryRequest.candidateMobile
        });
        let $this = this;
        this.timeleft = 10;
        let timer = setInterval(function() {
          $this.timeleft -= 1;
          if ($this.timeleft <= 0) {
            clearInterval(timer);
          }
        }, 1000);
        this.otpRequested = true;
      } catch {
        // Error
      }
    },

    verifyOtp: async function() {
      var otpRegex = /\d{6}/;
      if (!this.otpInput.match(otpRegex)) {
        alert("OTP Input must be 6 digits");
        return;
      }
      try {
        await http.post("/otp/validate", {
          mobile: this.ministryRequest.candidateMobile,
          otp: this.otpInput
        });
        this.showUserDetails = true;
        this.otpVerified = true;
        this.findApprover();
      } catch (err) {
        console.log("otp error", err);
        alert(err.response.data.message);
      }
    },
    validateOtp: function() {
      this.errors = [];
      var mobileRegex = /[8|9]\d{7}/;
      if (typeof this.ministryRequest.candidateMobile === "undefined") {
        this.errors.push("Your mobile is required.");
      } else if (!this.ministryRequest.candidateMobile.match(mobileRegex)) {
        this.errors.push("Not a mobile number");
      }
      return this.errors.length;
    },

    validate: function() {
      this.errors = [];
      var mobileRegex = /[6|8|9]\d{7}/;
      var emailRegex = /^.+@.+\..+$/;

      // Validate user
      if (typeof this.ministryRequest.candidateMobile === "undefined") {
        this.errors.push("Your mobile is required.");
      } else if (!this.ministryRequest.candidateMobile.match(mobileRegex)) {
        this.errors.push("Your mobile format is incorrect.");
      }

      if (typeof this.ministryRequest.candidateName === "undefined") {
        this.errors.push("Your name is required.");
      }

      if (
        this.ministryRequest.candidateEmail !== "" &&
        !this.ministryRequest.candidateEmail.match(emailRegex)
      ) {
        this.errors.push("Your email format is incorrect.");
      }

      if (!this.ministryRequest.noLG && !this.isLeader) {
        if (this.ministryRequest.congregation === "") {
          this.errors.push("Your congregation is required.");
        }

        if (this.ministryRequest.centre === "") {
          this.errors.push("Your centre is required.");
        }

        if (this.ministryRequest.lifegroup === "") {
          this.errors.push("Your lifegroup is required.");
        }

        if (this.approver === "") {
          this.errors.push("Your approver is required");
        }
      }
      return this.errors.length;
    }
  },
  watch: {
    ministryRequest: {
      handler: async function(val, oldVal) {
        if (this.ministryRequest.lifegroup !== "") {
          let response = await http.get(
            "/structure/filter?q=find approver&term=" +
              this.ministryRequest.lifegroup
          );
          this.approvers = response.data;
          this.showApproverDetails = true;
        }
      },
      deep: true
    }
  },
  beforeMount: function() {
    this.getMinistryRole();
    this.getCentres();
    this.success = false;
  }
};
</script>

<style>
</style>
